import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';

class AddDeviceModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'add-device-modal';
  }

  renderContents() {
    return html`
      <h3 slot="title">Add Device</h3>

      <bn-action
        .href="${this.href}"
        actionname="add-device"
        successtext="Deviced added. Redirecting."
        errortext="Failed to add device."
        @response="${this._onResponse}"
      >
        <span slot="header"></slot>
      </bn-action>
    `;
  }

  _onResponse(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }

    setTimeout(() => {
      this.close();
      store.dispatch(storeActions.navigate('/devices/show', { deviceId: entity.getLinkByRel('self').href }));
    }, 1000);
  }
}

window.customElements.define('add-device-modal', AddDeviceModal);
